export default "__VITE_ASSET__pBwVAIkU__"